export const getInheritedFieldOpsExclusion = (
  stages = [],
  targetStageId,
  inheritedExcluded = false,
) => {
  if (!targetStageId || !Array.isArray(stages)) return false;

  for (const stage of stages) {
    const nextInheritedExcluded =
      inheritedExcluded || Boolean(stage.exclude_from_field_ops);

    if (stage.id === targetStageId) {
      return nextInheritedExcluded;
    }

    if (Array.isArray(stage.stages) && stage.stages.length > 0) {
      const nestedResult = getInheritedFieldOpsExclusion(
        stage.stages,
        targetStageId,
        nextInheritedExcluded,
      );

      if (nestedResult) return true;
    }
  }

  return false;
};
